//@flow
import OrderClass from './orderClass';

export default new OrderClass();
